import { useOutletContext } from "react-router"
import { chPatientEpisodesOfCareQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientEpisodesOfCareQuery.graphql"
import { dePatientEpisodesOfCareQuery$data } from "@/modules/patients/services/de/__generated__/dePatientEpisodesOfCareQuery.graphql"

const usePatientEpisodesOfCareData = () => {
  const { patientEpisodesOfCareData } = useOutletContext<{
    patientEpisodesOfCareData: dePatientEpisodesOfCareQuery$data & chPatientEpisodesOfCareQuery$data
  }>()

  return patientEpisodesOfCareData
}

export { usePatientEpisodesOfCareData }
